import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';

import { Button } from 'app/src/elements/buttons';
import { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';

import { currency } from './index';
import {
  CLEAR_OFFER_RESULT,
  UPDATE_LAST_OFFER_PRICE,
  REINSTATE_SALE_ASSET,
} from './queries';
import { UNWIND_SOLD_ASSET } from 'app/src/components/Assets/queries';

const EditPrice = styled(View)`
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: black;
  padding-top: 10px;
`;

export const EditStatus = ({ saleAsset, setShowModal }) => {
  const offer = saleAsset.activeOffer;

  let lastPrice = offer.price;
  let offerType = `buyer offer`;

  if (offer.counterPrice) {
    lastPrice = offer.counterPrice;
    offerType = `last seller counter`;
  } else if (offer.prior) {
    offerType = `last buyer counter`;
  }

  const [price, setPrice] = useState(lastPrice || '');

  const [clearOfferResult] = useMutation(CLEAR_OFFER_RESULT, {
    onCompleted: () => setShowModal(false)
  });

  const [unwindSoldAsset] = useMutation(UNWIND_SOLD_ASSET, {
    onCompleted: () => setShowModal(false)
  });

  const [updateLastOfferPrice] = useMutation(UPDATE_LAST_OFFER_PRICE, {
    onCompleted: () => setShowModal(false)
  });

  const [reinstateSaleAsset] = useMutation(REINSTATE_SALE_ASSET, {
    onCompleted: () => setShowModal(false)
  });

  const confirmClearResult = result => {
    //if (confirm(`Really clear ${result} result?`)) {
      clearOfferResult({ variables: { saleAssetId: saleAsset.id } });
    //}
  };

  const confirmUnwind = () => {
    if (confirm('Really unwind the sale of this asset?')) {
      unwindSoldAsset({ variables: { id: saleAsset.id } });
    }
  };

  const confirmReinstate = () => {
    if (confirm('Really clear offers and re-add to sale?')) {
      reinstateSaleAsset({ variables: { id: saleAsset.id } });
    }
  };

  const clearLastPrice = () => {
    updateLastOfferPrice({
      variables: { saleAssetId: saleAsset.id, price: null }
    });
  };

  const updateLastPrice = ({ isIf }) => {
    updateLastOfferPrice({
      variables: {
        saleAssetId: saleAsset.id,
        price: (price || null),
        isIf
      }
    });
  };

  if (['Unwound', 'Removed'].includes(saleAsset.status)) {
    return (
      <View>
        <Text>Status cannot be changed because sale has been unwound.</Text>
      </View>
    );
  } else if (saleAsset.invoiceNumber) {
    return (
      <View>
        <Text>Status cannot be changed because buyer has been invoiced.</Text>
        <Text>
          Clear the invoice number if needed or click below to Unwind sale.
        </Text>
        <Button
          label="UNWIND Sale (will be available for future sales)"
          onPress={confirmUnwind}
          wide
        />
      </View>
    );
  } else if ('Sold' === offer.result) {
    return (
      <>
        <Button
          label="Clear SOLD status"
          onPress={() => confirmClearResult('Sold')}
          wide
        />
        <Button
          label="CLEAR offer and re-add to sale"
          onPress={confirmReinstate}
          wide
        />
        <Button
          label="UNWIND Sale (will be available for future sales)"
          onPress={confirmUnwind}
          wide
        />
        {!offer.isIf && (
          <Button
            label="Convert to IF and clear SOLD status"
            onPress={() => confirmClearResult('Sold')}
            wide
          />
        )}
      </>
    );
  } else if ('Declined' === offer.result) {
    return (
      <View>
        <Button
          label="Clear DECLINED status"
          onPress={() => confirmClearResult('Declined')}
          wide
        />
        <Button
          label="CLEAR offer and re-add to sale"
          onPress={confirmReinstate}
          wide
        />
      </View>
    );
  } else if (!offer.price) {
    return (
      <View>
        <Text>No offer has been entered.</Text>
        <Button
          label="REMOVE from Sale (will be available for future sales)"
          onPress={confirmUnwind}
          wide
        />
        {!offer.isIf && (
          <Button
            label="Make IF Sale"
            onPress={() => updateLastPrice({ isIf: true })}
            wide
          />
        )}
        <EditPrice>
          <FieldLabel label="Enter Price as IF Sale" />
          <StyledTextInput
            onChange={e => setPrice(e.target.value)}
            value={price}
          />
        </EditPrice>
        <Button
          label="Set Price as IF"
          onPress={() => updateLastPrice({ isIf: true })}
          wide
        />
      </View>
    );
  } else {
    return (
      <View>
        {!offer.isIf && (
          <Button
            label="Convert to IF"
            onPress={() => confirmClearResult('non-IF')}
            wide
          />
        )}
        <Button
          label={`Clear ${offerType} of ${currency(lastPrice)}`}
          onPress={clearLastPrice}
          wide
        />
        <Button
          label="CLEAR offer and re-add to sale"
          onPress={confirmReinstate}
          wide
        />
        <Button
          label="UNWIND Sale (will be available for future sales)"
          onPress={confirmUnwind}
          wide
        />
        <EditPrice>
          <FieldLabel label={`Change ${offerType} to:`} />
          <StyledTextInput
            onChange={e => setPrice(e.target.value)}
            value={price}
          />
        </EditPrice>
        <Button
          label="Update Price"
          onPress={updateLastPrice}
          wide
        />
      </View>
    );
  }
};

export default EditStatus;
